<template>
    <el-container>
        <el-scrollbar style="height: 100%;background-color: #26347f;min-width: 220px;transition:all 0.2s ease;" :class="changecalss">
            <el-aside width="220px">
                <hrr-left />
            </el-aside>
        </el-scrollbar>
        <el-container>
            <el-header class="el-header-con">
                <hrr-head v-on:changeSize="changeSize" />
            </el-header>
            <el-main class="el-main-con">
                <router-view v-on:loginout="conloginout" />
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import HrrLeft from './Left.vue';
import HrrHead from './Head.vue';

export default {
    name: 'console',
    data: function() {
        return {
            changecalss: ""
        }
    },
    components: {
        HrrLeft,
        HrrHead
    },
    methods: {
        changeSize() {
            if (this.$store.state.Collapse) {
                this.changecalss = "el-scrollbar-change";
            } else {
                this.changecalss = "";
            }
        },
        conloginout() {
            var Vthis = this;
            this.$hrraxios.get(this.$api.base.loginout)
                .then((response) => {
                    var mydata = response.data;
                    if (mydata.Success == true) {
                        Vthis.$store.commit('setUserId', "");
                        Vthis.$store.commit('setUserName', "");
                        Vthis.$store.commit('setOrganName', "");
                        sessionStorage.clear();
                        Vthis.$router.push({ path: '/login' });
                    } else {
                        Vthis.$message.error("登出失败,请联系管理员");
                    }
                })
                .catch((error) => {
                    Vthis.$message.error("登出失败,请联系管理员");
                    console.log(error);
                })
        }
    }
};
</script>
<style>
.el-container {
    height: 100%;
}

.el-scrollbar__wrap {
    overflow-x: hidden !important;
}

.el-scrollbar-change {
    min-width: 65px !important;
    width: 65px;
}
.el-header-con{
    background-color:#f2f2f2;
}
</style>